function fn_comp_parallax() {
    var $fn = $(".comp_parallax");
    if ($fn.length) {
        $.getScript("https://cdnjs.cloudflare.com/ajax/libs/parallax/2.1.3/parallax.min.js", function() {
            var $params = null;
            if ($(window).width() < 600) {
                $params = {
                    scalarX: 24,
                    scalarY: 24
                };
            }

            var $scene = $fn.find("[data-parallax-scene]").get(0),
                parallax = new Parallax($scene,$params);

            $fn.find("[data-scroll-down]").on("click", function(e){
               e.preventDefault();
               var $offset = 0;
                if ($(window).width() > 960) {
                    $offset = $("#layout_header .elm_header_nav").innerHeight();
                }
                $('html, body').animate({
                    scrollTop: $fn.next().offset().top - $offset
                }, 800);
            });

            if ($(window).width() > 1200 && !(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0)) {
                fn_nl_fog($fn, $scene);
            }

            if (window.location.hash == "#teo") {
                $fn.find(".layer--2").addClass("mod--teo");
            }
        });
    }
}